import React from 'react';
import PropTypes from 'prop-types';
import {Tabs, Tab} from '@mui/material';
import styled from '@emotion/styled';
import {theme} from '../../../themes/default-theme';

const TabsContainer = styled(props => {
  return <Tabs {...props} />
})`
  &:hover: {
    outline: 'none',
  }
  & .MuiTabs-indicator {
    background: none;
  }
  &.socials {
    max-width: 480px;
    margin: 52px auto;
  }
`;

const TabSelect = styled(props => {
  return <Tab {...props} classes={{selected: 'selected'}} />
})`
  & {
    font-size: 17px;
    color: ${theme.palette.gunmentalGrey};
    background : ${theme.palette.white};
    text-transform: capitalize;
    font-weight: 400;
    border: 1px solid ${theme.palette.middleGrey};
    ${theme.breakpoints.down("sm")} {
      font-size: 12px;
    }
  }
  &.selected {
    color: ${theme.palette.white};
    background-color: ${theme.palette.vividBlue};
    border: 1px solid ${theme.palette.vividBlue};
  }
  min-width: 160px;
  &:first-child {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }
  &:last-child {
    border-bottom-right-radius: 8px;
    border-top-right-radius: 8px;
  }
`;

export const TabSelection = props => {
  const [internalValue, setInternalValue] = React.useState(props.activeIndex || 0);
  const {data, variant, socials, value} = props;
  
  // Use controlled value if provided, otherwise use internal state
  const currentValue = value !== undefined ? value : internalValue;

  const handleChange = (event, newValue) => {
    // Update internal state only if not controlled
    if (value === undefined) {
      setInternalValue(newValue);
    }
    props.onChange(newValue);
  };

  return (
    <TabsContainer
      className={socials && 'socials'}
      value={currentValue}
      onChange={handleChange}
      variant={variant}
      centered={true}
    >
      {data && data.map(function(tab, index) {
        return (
          <TabSelect
            key={tab.id || index}
            label={tab.title} 
          />
        )
      })}
    </TabsContainer>
  );
}

TabSelection.propTypes = {
  data: PropTypes.array,
  variant: PropTypes.string,
  onChange: PropTypes.func,
  activeIndex: PropTypes.number,
  value: PropTypes.number,
  socials: PropTypes.bool
};

TabSelection.defaultProps = {
  variant: 'fullWidth',
  onChange: () => {},
  activeIndex: 0
};

export default TabSelection;
